<input
  type="text"
  class="form-control"
  [ngClass]="cssClass"
  [id]="inputId || null"
  [placeholder]="placeholder"
  [formControl]="control"
  [matAutocomplete]="matAutocomplete"
/>
